/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from "react";
// import M_logo from '../../assets/logo M.png';
import { PiPlusThin } from "react-icons/pi";
import { GrCircleInformation } from "react-icons/gr";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { FiUpload } from "react-icons/fi";
import { ImSpinner9 } from "react-icons/im";
import { FaBell } from "react-icons/fa";
import axios from "axios";
import DocumentTitle from "../../utils/DocumentTitle";
import Back from "../back/Back";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { update } from 'lodash';
import Flag from "react-world-flags";
import { MdLayers } from "react-icons/md";
import { MdLayersClear } from "react-icons/md";
import socket from "../../services/socket";

const Tome = () => {
  DocumentTitle("Mangas.IO translator");
  let tomeObj = {
    nom: "",
    fk_document_VO: "",
    langue_source: "zh-cn",
    langue_cible: "FR",
    statut: "Bubble detection",
    fk_utilisateur: "",
    fk_serie: "",
  };
  let [tome, setTome] = useState(tomeObj);
  let [relatedSerie, setRelatedSerie] = useState({});
  let [listOfTomes, setListOfTomes] = useState([]);
  const navigate = useNavigate();
  const [isLogedin, setIsLogedIn] = useState();
  const { id } = useParams();
  const [isCreated, setIsCreated] = useState(false);
  const [creating, setCreating] = useState("Create");
  // const [info, setInfo] = useState(true)
  // const [setting, setSetting] = useState(false)
  const [loggedUser, setLoggedUser] = useState({});
  const [tomeCreating, setTomeCreating] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [newNotifications, setNewNotifications] = useState([]);
  const [group, setGroup] = useState();
  // const [usersActive, setUsersActive] = useState([]);

  // get equipe
  useEffect(() => {
    if (relatedSerie?._id) {
      const token = localStorage.getItem("login_token");
      if (token) {
        try {
          axios
            .get(
              `${process.env.REACT_APP_HOST_API}/api/serie/${relatedSerie._id}/users`,
              {
                headers: { Authorization: token },
              }
            )
            .then((res) => {
              console.log("group : ", res.data);
              setGroup(res.data);
            });
        } catch (error) {
          toast.error("Something wrong while getting assigned users");
        }
      }
    }
  }, [relatedSerie]);

  // get all notifications
  useEffect(() => {
    try {
      const token = localStorage.getItem("login_token");
      const user = JSON.parse(localStorage.getItem("login_user"));
      if (token && user) {
        axios
          .get(
            `${process.env.REACT_APP_HOST_API}/api/notification/get/${user.id}`,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            let newOnes = res.data.filter((n) => n.statut === "sent");
            setNewNotifications([...newOnes]);
            setNotifications([...res.data]);
            console.log("res notifications : ", res.data);
          });
      }
    } catch (error) {
      toast.error("Can't get notifications");
    }
  }, []);

  // get tomes and related serie
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    const user = JSON.parse(localStorage.getItem("login_user"));
    socket.emit("userConnectedOut", user?.id, "out");
    setLoggedUser(user);
    if (!token) {
      navigate("/login");
      setIsLogedIn(false);
    } else {
      setIsLogedIn(true);
      // get relared serie
      axios
        .get(`${process.env.REACT_APP_HOST_API}/api/serie/${id}`, {
          headers: { Authorization: token },
        })
        .then((res) => {
          setRelatedSerie({ ...res.data });
          console.log("res related serie : ", res.data);
        });
      // get all tomes
      axios
        .get(`${process.env.REACT_APP_HOST_API}/api/tome/serie/${id}`, {
          headers: { Authorization: token },
        })
        .then((res) => {
          setListOfTomes([...res.data]);
          console.log("res all tomes: ", res.data);
        });
    }
  }, [id, isCreated]);

  // show hide sub list
  const [toggleSubList, setToggleSubList] = useState(false);
  const showHideSubList = () => {
    setToggleSubList(!toggleSubList);
  };

  document.addEventListener("click", (e) => {
    if (toggleSubList && e.target.id !== "avatar") {
      setToggleSubList(false);
    }
  });
  // to open the modale add tome
  let [isOpened, setIsOpened] = useState(false);

  const openAddTomeModale = () => {
    setIsOpened(true);
  };

  const closeAddTomeModale = (e) => {
    let id = e.target.id;
    if (id === "add_tome_modale" || id === "back") {
      setIsOpened(false);
    }
  };
  // end
  // create a tome

  const [fileName, setFileName] = useState("");
  const [pdfFile, setPdfFile] = useState("");
  const hiddenFileInput = useRef(null);

  const handleClickPdf = () => {
    hiddenFileInput.current.click();
  };

  const handleChangePdf = (event) => {
    const fileUploaded = event.target.files[0];
    setFileName(fileUploaded.name);
    setPdfFile(fileUploaded);
    // setTome({ ...tome, fk_document_VO: fileUploaded.name });
    // console.log(fileUploaded)
    // console.log("file : ", event.target.files)
  };

  // to push the obj in the list of tomes
  const createTome = async () => {
    console.log("tome : ", tome);
    console.log("pdfFile ", pdfFile.type);
    const form = document.getElementById("createTomeForm");
    if (tome.nom.trim() === "") {
      toast.error("Please provide a title for the new tome.");
    }
    if (pdfFile.type !== "application/pdf") {
      toast.error("Please provide a pdf file.");
    }
    const token = localStorage.getItem("login_token");
    if (token && tome.nom.trim() !== "" && pdfFile.type === "application/pdf") {
      setCreating("Creating");
      setTomeCreating("creating");
      console.log("tome ", tome);
      let formData = new FormData();
      formData.append("file", pdfFile);
      try {
        // send serie with axios S3FileUpload
        await axios
          .post(`${process.env.REACT_APP_HOST_API}/api/aws/upload`, formData, {
            headers: {
              Authorization: token,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              setTomeCreating("almost");
              let tomeObj = {
                ...tome,
                numero: listOfTomes.length + 1,
                path: res.data,
                doc: {
                  ref: "ref00001",
                  type: "PDF",
                  nom: `${tome.nom}.pdf`,
                  langue: tome.langue_source,
                  chemin: res.data,
                },
              };
              console.log("tome obj : ", tomeObj);
              console.log("res : ", res);
              try {
                // send serie with axios
                axios
                  .post(`${process.env.REACT_APP_HOST_API}/api/tome`, tomeObj, {
                    headers: { Authorization: token },
                  })
                  .then((res) => {
                    if (res.status === 200) {
                      console.log("tome created : ", res.data);
                      setTomeCreating("");
                      setIsCreated(res.data);
                      setIsOpened(false);
                      setCreating("Create");
                      let action = {
                        fk_utilisateur: loggedUser.id,
                        fk_serie: relatedSerie._id,
                        fk_tome: res.data._id,
                        contenu: `${loggedUser.username} has added a new tome "${res.data.nom}" to the serie "${relatedSerie.titre}"`,
                        target_user: "",
                        date: res.data.date_creation,
                        statut: "sent",
                      };
                      let sendTo = group.filter(
                        (el) => el._id !== loggedUser.id
                      );
                      socket.emit("createTome", action, sendTo);
                      form.reset();
                      console.log("tome created : ", res);
                      console.log("action : ", action);
                    }
                  });
              } catch (error) {
                console.log(error);
              }
            }
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  // to get data from the form
  const onChangeHandler = (e) => {
    setTome({
      ...tome,
      [e.target.name]: e.target.value,
      fk_utilisateur: relatedSerie.fk_utilisateur,
      fk_serie: relatedSerie._id,
    });
    console.log(tome);
  };
  // end

  // edit tome
  let [edit, setEdit] = useState(false);
  let [updatedTome, setUpdatedTome] = useState({});
  // let [newtomeUpdated, setNewtomeUpdated] = useState({});

  const editTome = async (t, idx) => {
    // setUpdatedTome({});
    console.log("t ", t);
    setEdit(!edit);
    const token = localStorage.getItem("login_token");
    if (token) {
      axios
        .get(`${process.env.REACT_APP_HOST_API}/api/user/${t.fk_utilisateur}`, {
          headers: { Authorization: token },
        })
        .then((res) => {
          if (res.status === 200) {
            // console.log("req ", `${process.env.REACT_APP_HOST_API}/api/documentVO/${updatedTome.fk_document_VO}`)
            axios
              .get(
                `${process.env.REACT_APP_HOST_API}/api/documentVO/${t.fk_document_VO}`,
                {
                  headers: { Authorization: token },
                }
              )
              .then((res2) => {
                if (res2.status === 200) {
                  setUpdatedTome({
                    ...t,
                    idx,
                    fileName: res2.data.chemin.split("/").at(-1),
                    nom_utilisateur: res.data.nom_utilisateur,
                  });
                  console.log("res ", res2.data.chemin.split("/").at(-1));
                  // setUpdatedTome({ ...t, idx, fileName:res.data.chemin.split('/').at(-1)});
                }
              });
          }
        });
    }
  };
  // update : on change
  // const onUpdateHandler = (e) => {
  //     let newTome = { ...updatedTome, [e.target.name]: e.target.value };
  //     setUpdatedTome(newTome);
  // }
  // update a tome

  // const updateTome = () => {
  //     let listOfTomesUpdated = listOfTomes.filter(tome => tome.idx !== updatedTome.idx);
  //     listOfTomesUpdated.splice(updatedTome.idx, 0, updatedTome);
  //     setListOfTomes(listOfTomesUpdated)
  //     console.log(listOfTomes);
  //     console.log(listOfTomesUpdated);
  // }

  // back from update form
  const closeUpdateTomeModale = (e) => {
    // console.log(updatedTome)
    let id = e.target.id;
    if (id === "add_tome_modale_update" || id === "back_update") {
      setEdit(false);
      setUpdatedTome({});
    }
  };

  // auto read notifs
  const updateNotifsWhenOpen = async (notifications) => {
    const token = localStorage.getItem("login_token");
    if (token) {
      for (let i = 0; i < notifications.length; i++) {
        if (notifications[i].statut === "sent") {
          try {
            await axios
              .put(
                `${process.env.REACT_APP_HOST_API}/api/notification/update_statut/${notifications[i]._id}`,
                {},
                {
                  headers: { Authorization: token },
                }
              )
              .then((res) => {
                console.log("res update notifs to seen : ", res);
                if (res.status === 200) {
                  setNewNotifications([]);
                }
              });
          } catch (error) {
            console.log("update notif to seen err : ", error);
          }
        }
      }
    }
  };

  const [toggleNotif, setToggleNotif] = useState(false);
  useEffect(() => {
    console.log("toggleNotif : ", toggleNotif);
    console.log("notifications : ", notifications);
    if (toggleNotif && notifications.length !== 0) {
      updateNotifsWhenOpen(notifications);
      setNewNotifications([]);
    }
  }, [toggleNotif]);

  // show notifications start
  const showHideNotif = () => {
    setToggleNotif(!toggleNotif);
  };

  document.addEventListener("click", (e) => {
    let el = e.target.id || e.target.parentElement?.id;
    if (el !== "notif") {
      setToggleNotif(false);
    }
  });
  // show notifications end

  // socket get notifs
  useEffect(() => {
    if (relatedSerie?._id) {
      socket.on("notification", (list) => {
        let newList = list.filter((el) => el.target_user === loggedUser.id);
        setNewNotifications([...newNotifications, ...newList]);
        setNotifications([...notifications, ...newList]);
      });
    }

    return () => {
      socket.off("notification");
    };
  }, [loggedUser?.id, relatedSerie]);
  console.log("notifications : ", notifications);
  console.log("newNotifications : ", newNotifications);
  console.log("listOfTomes : ", listOfTomes);

  if (isLogedin) {
    return (
      <div className="tomes_container">
        <div className="tomes_header">
          <div className="tomes_logo">
            {/* <img src={M_logo} alt="MangasIO_Logo" />
             */}
            <img
              src={require("../../assets/logo mangasio.svg").default}
              alt="mySvgImage"
              onClick={() => navigate("/series")}
            />
            <Link to="/series" title="Back to series" className="back">
              <IoIosArrowBack />
            </Link>
          </div>
          <div className="tomes_search">
            <div className="input">
              {relatedSerie.titre} {">"} Tomes
            </div>
          </div>
          <div className="tomes_avatar">
            <div
              id="notif"
              className="notif"
              title="Notifications"
              onClick={showHideNotif}
              style={newNotifications.length !== 0 ? { color: "#bd2969" } : {}}
            >
              <FaBell id="notif" />
              <span className="num_of_notifs">
                {newNotifications?.length < 10
                  ? newNotifications?.length
                  : "+9"}
              </span>
            </div>
            <div
              id="avatar"
              className="avatar"
              onClick={showHideSubList}
              style={
                toggleSubList
                  ? {
                      border: "1px solid rgb(214, 65, 10)",
                      color: "rgb(214, 65, 10)",
                    }
                  : { border: "none", color: "black" }
              }
            >
              {loggedUser?.username[0].toUpperCase()}
            </div>
            {toggleSubList && (
              <div className="sub_list">
                <Link className="item" to="/profile">
                  Settings
                </Link>
                <Link className="item" to="/logout">
                  Sign out
                </Link>
              </div>
            )}
            {toggleNotif && (
              <div className="notif_list">
                {notifications?.length !== 0 ? (
                  [...notifications].reverse()?.map((n, i) => {
                    return (
                      <span
                        key={i}
                        className="nofit_item"
                        style={
                          n.statut === "seen"
                            ? { backgroundColor: "#1510188f" }
                            : { backgroundColor: "#bd2969" }
                        }
                      >
                        {n.contenu}
                      </span>
                    );
                  })
                ) : (
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: ".8rem",
                      color: "#e8e5e5",
                    }}
                  >
                    No notifications yet !!
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="tomes_content">
          <h2>Tomes</h2>
          <div className="tomes_cards">
            <div
              className="add_tome_card"
              title="Add new tome"
              onClick={openAddTomeModale}
            >
              <div className="add_tome_icon">
                <PiPlusThin />
              </div>
              <div className="add_tome_text">Create a new Tome</div>
            </div>
            {listOfTomes.map((t, idx) => {
              return (
                <div className="tome_card" key={idx}>
                  <Link to={"/edition/" + t._id}>{t.nom}</Link>
                  <span className="flag">
                    <Flag
                      code={t.langue_cible === "en_gb" ? "GB" : t.langue_cible}
                      width="100%"
                    />
                  </span>
                  <span
                    className="isLayered"
                    style={{
                      color:
                        t?.isLayered === true
                          ? "rgb(4, 140, 4)"
                          : "rgb(63, 63, 63)",
                    }}
                    title={t?.isLayered === true ? "Layered" : "Flattened"}
                  >
                    {t?.isLayered === true ? <MdLayers /> : <MdLayersClear />}
                  </span>
                  <span className="tome_card_details">
                    <div className="row">
                      <span>Serie : {relatedSerie.titre}</span>
                      <span
                        className="edit"
                        title="Info"
                        onClick={() => editTome(t, idx)}
                      >
                        <GrCircleInformation />
                      </span>
                    </div>
                    <div className="row">
                      <span>Tome : {idx + 1}</span>
                    </div>
                    <div className="row">
                      <span>Status : {t.statut}</span>
                    </div>
                  </span>
                </div>
              );
            })}
          </div>
        </div>
        {/* add tome modale */}
        {isOpened && (
          <div
            id="add_tome_modale"
            className="add_tome_modale"
            onClick={closeAddTomeModale}
          >
            <div className="add_tome_modale_content">
              <h2>Create New Tome</h2>
              <form
                action="/upload_pdf"
                method="post"
                encType="multipart/form-data"
                id="createTomeForm"
              >
                <div className="add_tome_form">
                  <div className="add_tome_form_left">
                    <div className="input_block">
                      <label htmlFor="nom">Titre</label>
                      <input
                        type="text"
                        name="nom"
                        id="nom"
                        placeholder="Titre"
                        onChange={onChangeHandler}
                      />
                    </div>
                    <div className="input_block">
                      <label htmlFor="upload">Upload pdf</label>
                      <div id="file_pdf_block">
                        <input
                          type="text"
                          className="upload"
                          placeholder="Charger PDF"
                          onClick={handleClickPdf}
                          readOnly
                          value={fileName}
                        />
                        <span className="upload_icon">
                          <FiUpload />
                        </span>
                      </div>
                      <p className="pdf_size">recommended size is 300MB</p>
                      <input
                        type="file"
                        name="pdf_file"
                        id="pdf_file"
                        className="pdf_file"
                        ref={hiddenFileInput}
                        onChange={handleChangePdf}
                      />
                    </div>
                  </div>
                  <div className="add_tome_form_right">
                    <div className="input_block">
                      <label htmlFor="langue_source">Source language</label>
                      <select
                        type="text"
                        name="langue_source"
                        id="langue_source"
                        onChange={onChangeHandler}
                      >
                        <option value="zh-cn">CN</option>
                        <option value="zh-cn">TW</option>
                        <option value="ja">JAP</option>
                        <option value="ko">KO</option>
                      </select>
                    </div>
                    <div className="input_block">
                      <label htmlFor="langue_cible">Target language</label>
                      <select
                        type="text"
                        name="langue_cible"
                        id="langue_cible"
                        onChange={onChangeHandler}
                      >
                        <option value="fr">FR</option>
                        <option value="es">ES</option>
                        <option value="en_gb">EN</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="add_tome_form_btns">
                  <button
                    type="button"
                    id="back"
                    onClick={closeAddTomeModale}
                    disabled={creating === "Creating" ? true : false}
                  >
                    Back
                  </button>
                  {creating === "Creating" && (
                    <div className="add_tome_loading">
                      <span className="creating">
                        <ImSpinner9 />
                      </span>
                      <span className="creating_tome">
                        {tomeCreating === "creating"
                          ? "Tome is creating please wait"
                          : "Almost done"}
                      </span>
                    </div>
                  )}
                  <button
                    type="button"
                    id="cree"
                    onClick={createTome}
                    disabled={creating === "Creating" ? true : false}
                    style={
                      creating === "Creating"
                        ? { opacity: "0.5", cursor: "not-allowed" }
                        : {}
                    }
                  >
                    Create
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* edit tome modale */}
        {edit && (
          <div
            id="add_tome_modale_update"
            className="add_tome_modale"
            onClick={closeUpdateTomeModale}
          >
            <div className="add_tome_modale_content">
              <h2>Tome Information</h2>
              <ul className="options">
                <li
                  id="info"
                  style={{ color: "#775DA6", borderColor: "#775DA6" }}
                  // onClick={toggleInfoSetting}
                >
                  Information
                </li>
                {/* <li id='setting' style={setting ? { color: '#775DA6', borderColor: '#775DA6' } : {}} 
                            // onClick={toggleInfoSetting}
                            >Settings</li> */}
              </ul>
              <div className="details_option">
                <div className="left">
                  <div>Title : {updatedTome?.nom}</div>
                  <div>
                    Date Of Creation :{" "}
                    {updatedTome?.date_creation?.split("T")[0]}
                  </div>
                  <div>Status : {updatedTome?.statut}</div>
                  <div>Creator : {updatedTome?.nom_utilisateur}</div>
                </div>
                <div className="right">
                  {/* <div>Title : {relatedSerie?.titre}</div> */}
                  <div>File Name : {updatedTome?.fileName}</div>
                  <div style={{ textTransform: "uppercase" }}>
                    Source Language :{" "}
                    {updatedTome?.langue_source === "zh-cn"
                      ? "CN"
                      : updatedTome?.langue_source === "ja"
                      ? "JAP"
                      : ""}
                  </div>
                  <div style={{ textTransform: "uppercase" }}>
                    Target Language : {updatedTome?.langue_cible}
                  </div>
                </div>
                <div></div>
              </div>
              {/* {setting && <div className="details_option">
                            <div>Title : {relatedSerie?.titre}</div>
                            <div>File Name : {updatedTome?.nom}</div>
                            <div>Source Language : {updatedTome?.langue_source}</div>
                            <div>Target Language : {updatedTome?.langue_cible}</div>
                        </div>} */}
              <div className="add_tome_form_btns">
                <button
                  type="button"
                  id="back_update"
                  onClick={closeUpdateTomeModale}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        )}
        <ToastContainer />
        <Back />
      </div>
    );
  }
};

export default Tome;
